// extracted by mini-css-extract-plugin
export default {"msgM":"_8da51d661d"};